const RICOS_VERSION = "10.151.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
